import '@/Foundation/styles/page.scss';
import '@/General/styles/page.scss';

import {createApp} from 'vue';

import vuetify from '@/Foundation/plugins/vuetify';
import App from '@/General/App.vue';
import i18n from '@/General/plugins/i18n';
import router from '@/General/plugins/router';
import store from '@/General/plugins/store';

const app = createApp(App);

app.use(i18n)
  .use(vuetify)
  .use(store)
  .use(router);

app.mount('#app-general-container');
